<!-- this creates a google map on the page with the given lat/lng from -->
<!-- the component as the initial center of the map: -->
<div class="map-container">
  <!-- <h1>{{ title }}</h1> -->
  <agm-map [latitude]="lat" [longitude]="lng" (mapReady)="mapReady($event)">
    <!-- <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker> -->
    <agm-marker-cluster>
      <agm-marker
        *ngFor="let tombstone of tombstonesFiltered"
        [latitude]="tombstone.lat"
        [longitude]="tombstone.lon"
        ><agm-info-window [disableAutoPan]="true">
          <p>cmentarz: {{ tombstone.cemetery }}</p>
          <p *ngFor="let person of tombstone.person">
            {{ person.firstName }} {{ person.lastName }}
            {{ person.birthDate }} -
            {{ person.dateOfDeath }}
          </p>
          <button
            mat-raised-button
            style="background-color: #3d0300; color: #dbd9b8"
            (click)="this.goToTombstone(tombstone)"
          >
            Zobacz szczegóły
          </button>
        </agm-info-window></agm-marker
      >
    </agm-marker-cluster>
  </agm-map>
</div>
